import { IWatrReimbursement, IWatrRequest } from '@nkr/models/index';
import { WageAndTravelCategory } from '@nkr/enums/index';
import { ILineItem } from './line-item.types';

export interface ILineItemUpdate {
    lineItemId: number;
    reviewRequired?: boolean;
    description?: string;
    amount?: number;
    expenseType?: number;
    expenseDate?: string;
    notes?: string;
    receiptFileId?: number;
    isCaregiverExpense?: boolean;
}

export interface IProps {
    data: IWatrRequest;
    isAudit: boolean;
    reimbursements: IWatrReimbursement[];
    category?: WageAndTravelCategory;
    onRequestRefresh?: () => Promise<void>;
}

export interface IDispatchProps {
    getTripsByTravelRequestId: (travelRequestId: number) => Promise<any>;
    getLineItemsByTripId: (tripId: number) => Promise<any>;
    approveTrip: (tripId: number, requestId: number, requiresEmail: boolean, lineItemUpdates?: ILineItemUpdate[]) => Promise<any>;
    declineTrip: (tripId: number, requestId: number, requiresEmail: boolean, lineItemUpdates?: ILineItemUpdate[]) => Promise<any>;
    verifyTravel: (
        travelRequestId: number,
        roundTripMiles: number,
        hotelLodgingExpense: number,
        flightAndTrainExpense: number,
        carServiceExpense: number,
        dependentCareExpense: number,
        mealExpense: number,
        isMilesOverWritten: boolean,
        overrideMiles: number,
        isMealsOverWritten: boolean,
        overrideMeals: number,
        isCarServiceExpenseOverridden: boolean,
        overrideCarServiceExpense: number,
        isDependentCareExpenseOverridden: boolean,
        overrideDependentCareExpense: number,
        isHotelLodgingExpenseOverridden: boolean,
        overrideHotelLodgingExpense: number,
        approvalEmail: any
    ) => Promise<any>;
}

export type TProps = IProps & IDispatchProps;

export interface IOverrideState {
    isMilesOverWritten: boolean;
    overrideMiles: number;
    isMealsOverWritten: boolean;
    overrideMeals: number;
    isCarServiceExpenseOverridden: boolean;
    overrideCarServiceExpense: number;
    isDependentCareExpenseOverridden: boolean;
    overrideDependentCareExpense: number;
    isHotelLodgingExpenseOverridden: boolean;
    overrideHotelLodgingExpense: number;
}

